/* eslint-disable
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS206: Consider reworking classes to avoid initClass
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class Bucket {
   data: any
   constructor(data: any) {
      this.set = this.set.bind(this)
      this.get = this.get.bind(this)
      this.clear = this.clear.bind(this)
      this.save = this.save.bind(this)
      this.timestamp = this.timestamp.bind(this)
      this.age = this.age.bind(this)
      this.data = data
      if (!this.data) {
         this.data = {values: {}}
         this.save()
      }
   }

   set(key: any, value: any) {
      this.data.values[key] = value
      return this.save()
   }

   get(key: any) {
      return this.data.values[key]
   }

   clear() {
      this.data.values = {}
      return this.save()
   }

   save() {
      this.timestamp()
      return this.persist(this.data)
   }

   timestamp() {
      return this.data.touched = (new Date).getTime()
   }

   age() { // in seconds
      return ((new Date).getTime() - this.data.touched) / 1000
   }

   persist(data: any) {}
}
// override this with something that accepts data and stores it

// NOTE: adding try/catch to localstorage calls. https://www.w3.org/TR/webstorage/#the-localstorage-attribute specification says that exceptions
// can be thrown, which might cause strange exceptions elsewhere. The bucket stores the data, so the only downside is that it is not really persisted 
// (but saved items UI still works unless page is refreshed) it returns false when persisting was not possible, so this can be handled by caller if needed.
let createStoreService: any = undefined
class StoreService {
   static initClass() {
      createStoreService = angular.noop
   }
   constructor() {
      this.bucket = this.bucket.bind(this)
      this.restore = this.restore.bind(this)
      return createStoreService.apply(this, arguments)
   }

   bucket(name: any, session=false) {
      return this.restore(name, session)
   }

   persist(name: any, data: any, session: any) {
      const serialized = JSON.stringify(data)
      let isPersisted = true
      if (session) {
         try {
            sessionStorage.setItem(name, serialized)
         } catch (error) {
            isPersisted = false
         }
      } else {
         try { 
            localStorage.setItem(name, serialized)
         } catch (error1) {
            isPersisted = false
         }
      }

      return isPersisted
   }

   restore(name: any, session: any) {
      let bucket
      const serialized = session ? (() => { try { return sessionStorage.getItem(name) } catch (error) {} })() : (() => { try { return localStorage.getItem(name) } catch (error1) {} })()

      if (serialized) {
         bucket = new Bucket(JSON.parse(serialized))
      } else {
         // @ts-expect-error TS(2554) FIXME: Expected 1 arguments, but got 0.
         bucket = new Bucket()
      }
      bucket.persist = data => {
         return this.persist(name, data, session)
      }
      return bucket
   }
}
StoreService.initClass()


angular.module('summonApp.services')
   .service('storeService', StoreService)
